import { FeatureCapabilities, User } from '@jooxter/api';

export const isUserWithCapabilities = (
  user?: User
): user is Omit<User, 'capabilities'> & { capabilities: { features: FeatureCapabilities } } => {
  return user && user?.capabilities && user.capabilities.features ? true : false;
};
